import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { Icon } from '../Icon';
var OpenHandSvg = function OpenHandSvg() {
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M9.833 3.965a1.13 1.13 0 0 1 .803-.337h1.137v8.506h1.363V6.617c0-.305.12-.597.333-.813a1.13 1.13 0 0 1 .804-.337h1.136v4.716q-.092.078-.177.163a2.54 2.54 0 0 0-.732 1.788v2.069h-.227a3.4 3.4 0 0 0-2.41 1.01 3.47 3.47 0 0 0-1 2.438v.92h1.364v-.92c0-.548.216-1.075.6-1.463a2.03 2.03 0 0 1 1.446-.606h1.59v-3.448c0-.305.12-.597.334-.813a1.13 1.13 0 0 1 .803-.336h1.136v4.827c0 1.28-.502 2.508-1.398 3.414a4.75 4.75 0 0 1-3.374 1.414h-2.728v1.38h2.728a6.1 6.1 0 0 0 4.339-1.819 6.24 6.24 0 0 0 1.797-4.389V9.605H17q-.114 0-.227.01V4.089h-2.5c-.399 0-.788.096-1.137.276V2.25h-2.5c-.663 0-1.299.266-1.767.74a2.54 2.54 0 0 0-.638 1.1H7c-.663 0-1.299.266-1.768.74A2.54 2.54 0 0 0 4.5 6.617v15.632h1.364V6.617c0-.305.12-.597.332-.813A1.13 1.13 0 0 1 7 5.467h1.136v6.667H9.5V4.778c0-.305.12-.597.333-.813"
  }));
};
export var OpenHand = function OpenHand(props) {
  return /*#__PURE__*/React.createElement(Icon, _extends({}, props, {
    component: OpenHandSvg
  }));
};